/* eslint-disable import/no-cycle */
import { Files } from '@flatsy/types/Files'
import { FetchStatus } from '@flatsy/types/FetchStatus'
import { createAsyncThunk } from '@reduxjs/toolkit'
import * as URLS from 'src/constants/Api'
import { RootState } from 'src/redux'
import client, { FlatsyApiError } from 'src/utils/client'
import { UpdateFiles } from './Type'

export const getFilesList = createAsyncThunk<
  Files[],
  string,
  {
    rejectValue: FlatsyApiError
  }
>(
  'files/getFilesList',
  async (applicationId, { rejectWithValue }) => {
    return client<Files[]>(URLS.APPLICANT_FILES(applicationId)).catch((err) => {
      return rejectWithValue(err)
    })
  },
  {
    condition: (_, { getState }) => {
      const status: FetchStatus = (getState as () => RootState)().files.fetchStatus
      if (FetchStatus.LOADING === status) {
        // Already fetched or in progress, don't need to re-fetch
        return false
      }
    },
  }
)

export const deleteFile = createAsyncThunk<
  Files[],
  {
    application: string
    file: string
  },
  {
    rejectValue: FlatsyApiError
  }
>('files/deleteFile', async (params, { rejectWithValue }) => {
  return client<Files[]>(URLS.DELETE_APPLICANT_FILES(params.application, params.file), {
    method: 'DELETE',
  }).catch((err) => {
    return rejectWithValue(err)
  })
})

export const UpdateApplicantFiles = createAsyncThunk<
  Files,
  {
    application: string
    files: UpdateFiles
  },
  {
    rejectValue: FlatsyApiError
  }
>('files/UpdateApplicantFiles', async (body, { rejectWithValue }) => {
  return client<Files, UpdateFiles>(URLS.APPLICANT_FILES(body.application), {
    body: body.files,
    method: 'POST',
  }).catch((err) => {
    return rejectWithValue(err)
  })
})
